// extracted by mini-css-extract-plugin
module.exports = {"dashboardTables":"Dashboard_dashboardTables__1xocD","adminTable":"Dashboard_adminTable__9E90n","collectionRow":"Dashboard_collectionRow__gDd2H"};